export const styles = {
  shuffleBanner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    height: "55px",
    maxWidth: "310px",
    gap: "3px",
    color: "events.textPrimary",
  },
  bodyText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
  },
};
